import type { UserPublicProfileJSON } from 'balus-common';

export class UserPublicProfile {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly imageUrl: string | null
  ) {}

  dump(): UserPublicProfileJSON {
    const { id, name, imageUrl } = this;
    return { id, name, imageUrl };
  }

  static load(dump: UserPublicProfileJSON): UserPublicProfile {
    const { id, name, imageUrl } = dump;
    return new this(id, name, imageUrl);
  }

  static compare(a: UserPublicProfile, b: UserPublicProfile): number {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  }

  match(keyword: string): boolean {
    if (keyword.trim() === '') return true;
    return this.name.toLocaleLowerCase().includes(keyword.trim().toLocaleLowerCase());
  }
}

export const isUserPublicProfile = (value: unknown): value is UserPublicProfile => {
  return value instanceof UserPublicProfile;
};
